import buildUrlLocation from "../helpers/buildUrlLocation";
import isEmpty from "../helpers/isEmpty";
import TagModel from "./TagModel";
import CategoryModel from "./CategoryModel";

class NewsModel {
  constructor(data) {
    this.id = data.id || "";
    if(data.title){
      this.title = this.truncateText(data.title,100);
    }
    if(data.shortContent){
      this.shortContent = this.truncateText(data.shortContent,300);
    }
    this.timestamp = data.timestamp || "";
    this.categoryId = data.categoryId || "";
    this.category = data.category || "";
    this.coverImage = data.coverImage || "";
    this.readMoreButton = data.readMoreButton || "";
    this.url = data.url || "";
    this.target = data.target || "_self";
    this.tags = [];
    if (!isEmpty(data.tags) && Array.isArray(data.tags)) {
      data.tags.forEach((tag) => this.tags.push(new TagModel(tag)));
    }
  }
  /**
   * Truncate string
   *
   * @param {string} text - text to truncate
   * @param {number} charsCount - number of chars to truncate
   * @returns {string} string
   */
  truncateText(text, charsCount){
    if (charsCount > text.length) {
      return text;
    }  
    var trimmedText = text.slice(0, charsCount);
    return trimmedText.slice(0, Math.min(trimmedText.length, trimmedText.lastIndexOf(" ")));
  }
  /**
   * Generate news card
   *
   * @returns {string} html in string format
   */
  generateNewsCard() {
    const variantClass = "item_press--primary";

    const postDate = new Date(this.timestamp).toLocaleDateString("en-us", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
    var coverImage = "";
    if(this.coverImage){
      coverImage=`<div class="new_press_short_img">
                      <img class="item_press--img" src="${this.coverImage}" alt="">
                    </div>`;
    }
    return `<a 
              class="content_box--item_press ${variantClass}"
              data-category-id="${this.categoryId}"
              data-news-id="${this.id}"
              href="${this.url}"
              target="${this.target}"
            >            
              ${coverImage}
                <div class="item_press--content">
                  <div class="news_press_post_tags">
                    ${CategoryModel.displayCategory(this.category)}                    
                  </div>
                  <h2 class="new_press_post_title">${this.title}</h2>
                  <div class="new_press_short_desc">${this.shortContent}</div>
                  <div class="box_button_read--more read_more--mobile-left">
                      <div>
                        <span class="read_more--red">${this.readMoreButton}</span>
                          <svg class="red-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                              stroke="currentColor" class="w-6 h-6">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                          </svg>
                      </div>
                  </div>
                 </div>               
            </a>
          `;
  }

  /**
   * Generate insight card
   *
   * @returns {string} html in string format
   */
  generateInsightCard() {
    const postDate = new Date(this.timestamp).toLocaleDateString("en-us", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    const title =
      this.title.length > 30 ? this.title.substring(0, 27) + "..." : this.title;

    return `<div class="content_box--item_insights" data-category-id="${this.categoryId}" data-news-id="${this.id}">
                <img class="item_insights--img" src="${this.coverImage}" alt=""><br>
                <div class="item_insights--content">
                    <span class="insight--date">${postDate}</span>
                    <h2 class="box_insights_item--left">
                        ${title}
                    </h2>
                </div>
                <div class="box_button_read--more read-more__fix read_more--mobile-left">
                    <a href="${this.url}">
                        <span class="read_more--red">${this.readMoreButton}</span>
                        <svg class="red-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                            stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                        </svg>
                    </a>
                </div>
            </div>`;
  }
}

export default NewsModel;
